/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_Aware_HelpInputs */



/**
* | output |
* | --- |
* | "Frame gap will be calculated using shot change markers" |
*
* @param {Shot_Change_Aware_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_aware_help = /** @type {((inputs?: Shot_Change_Aware_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_Aware_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L’écart sera calculé à partir des marqueurs de changement de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Frame-Lücke wird anhand der Shot-Wechsel-Markierungen berechnet.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'intervallo di frame verrà calcolato utilizzando i marcatori di cambio di inquadratura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разница между кадрами будет рассчитываться с помощью маркеров смены кадра.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La brecha de cuadro se calculará utilizando marcadores de cambio de tiro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将使用投篮变化标记来计算帧间隙。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームギャップはショットチェンジマーカーを使用して計算されます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तन मार्करों का उपयोग करके फ्रेम अंतराल की गणना की जाएगी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O intervalo entre frames será calculado usando marcadores de mudança de enquadramento.")
	return /** @type {LocalizedString} */ ("Frame gap will be calculated using shot change markers")
});